import { LoaderOptions, asNumber } from '@flipp/shopper-ad-web-shared';

export function overrideOptions(
  options: Readonly<LoaderOptions>,
): LoaderOptions {
  const url = new URL(window.location.toString());
  const dwellExpandable = url.searchParams.get('flipp-test-dwell-expandable');
  const experienceLimitRaw = url.searchParams.get(
    'flipp-test-experience-limit',
  );
  const experienceLimit = asNumber(experienceLimitRaw, 0);
  const startCompact = url.searchParams.get('flipp-test-start-compact');
  const dmaPixels = url.searchParams.get('flipp-test-dma-pixels');
  const nestedIframeResizing = url.searchParams.get(
    'flipp-test-nested-iframe-resizing',
  );
  const resizeWideInserts = url.searchParams.get('flipp-resize-wide-inserts');
  const expandOnReadMore = url.searchParams.get(
    'flipp-test-expand-on-read-more',
  );
  const rootElement = url.searchParams.get('flipp-test-root-element');
  const nestedIframeShared = url.searchParams.get(
    'flipp-test-nested-iframe-shared',
  );
  const wideCompact = url.searchParams.get('flipp-test-wide-compact');
  const wideCompactBackgroundColor = url.searchParams.get(
    'flipp-test-wide-compact-background-color',
  );

  const horizontal = url.searchParams.get('flipp-test-horizontal');
  const fixedHeightDynamicModule = url.searchParams.get(
    'flipp-test-fixed-height-dynamic-module',
  );
  const mobileSwipe = url.searchParams.get('flipp-mobile-swipe');
  const mobileSwipeAutoEngage = url.searchParams.get(
    'flipp-mobile-swipe-auto-engage',
  );
  const mobileSwipeAutoEngageIntervalMs = url.searchParams.get(
    'flipp-mobile-swipe-auto-engage-interval-ms',
  );
  const mobileSwipeFrameHeight = url.searchParams.get(
    'flipp-mobile-swipe-frame-height',
  );
  const ip = url.searchParams.get('flipp-test-ip');

  // eslint-disable-next-line functional/no-let
  let updatedOptions = { ...options };
  if (dwellExpandable !== null) {
    updatedOptions = {
      ...updatedOptions,
      dwellExpandable: dwellExpandable === 'true',
    };
  }
  if (experienceLimit) {
    updatedOptions = {
      ...updatedOptions,
      experienceLimit: Math.max(1, experienceLimit),
    };
  }
  if (startCompact !== null) {
    updatedOptions = {
      ...updatedOptions,
      startCompact: startCompact === 'true',
    };
  }
  if (dmaPixels !== null) {
    updatedOptions = {
      ...updatedOptions,
      dmaPixels: dmaPixels === 'true',
    };
  }
  if (nestedIframeResizing !== null) {
    updatedOptions = {
      ...updatedOptions,
      nestedIframeResizing: nestedIframeResizing === 'true',
    };
  }
  if (expandOnReadMore !== null) {
    updatedOptions = {
      ...updatedOptions,
      expandOnReadMore: expandOnReadMore === 'true',
    };
  }
  if (rootElement !== null) {
    updatedOptions = {
      ...updatedOptions,
      rootElement,
    };
  }
  if (nestedIframeShared !== null) {
    updatedOptions = {
      ...updatedOptions,
      nestedIframeShared: nestedIframeShared === 'true',
    };
  }
  if (wideCompact !== null && wideCompactBackgroundColor !== null) {
    updatedOptions = {
      ...updatedOptions,
      wideCompact: wideCompact === 'true',
      wideCompactBackgroundColor,
    };
  }
  if (horizontal !== null) {
    updatedOptions = {
      ...updatedOptions,
      fixedHeightUnit: horizontal === 'true' || horizontal === 'modal',
      fixedHeightUnitItemModal: horizontal === 'modal',
    };
  }
  if (fixedHeightDynamicModule !== null) {
    updatedOptions = {
      ...updatedOptions,
      fixedHeightDynamicModule: fixedHeightDynamicModule === 'true',
      fixedHeightUnit:
        updatedOptions.fixedHeightUnit || fixedHeightDynamicModule === 'true',
    };
  }

  if (resizeWideInserts !== null) {
    updatedOptions = {
      ...updatedOptions,
      resizeWideInserts: resizeWideInserts === 'true',
    };
  }

  if (mobileSwipe !== null) {
    updatedOptions = {
      ...updatedOptions,
      mobileSwipe: mobileSwipe === 'true',
    };
  }

  if (mobileSwipeAutoEngage !== null) {
    updatedOptions = {
      ...updatedOptions,
      mobileSwipeAutoEngageEnabled: mobileSwipeAutoEngage === 'true',
    };
  }

  if (mobileSwipeAutoEngageIntervalMs !== null) {
    const parsed = asNumber(mobileSwipeAutoEngageIntervalMs);
    if (parsed > 0) {
      updatedOptions = {
        ...updatedOptions,
        mobileSwipeAutoEngageIntervalMs: parsed,
      };
    }
  }

  if (mobileSwipeFrameHeight !== null) {
    const parsed = asNumber(mobileSwipeFrameHeight);
    if (parsed > 0) {
      updatedOptions = {
        ...updatedOptions,
        mobileSwipeFrameHeight: parsed,
      };
    }
  }

  if (ip !== null) {
    updatedOptions = { ...updatedOptions, ip };
  }

  return updatedOptions;
}
